import { IDocumentModel } from "./documents.interfaces";
import { IMediaModel } from "./media.interfaces";

export type TicketStatus = 'open' | 'closed';

export const ticketVariant = ['report', 'question'] as const;
export type TicketVariant = 'report' | 'question';

export const ticketReportSpace = [
  'apartment',
  'building',
  'surroundings',
  'common-areas',
  'other',
] as const;
export type TicketReportSpace =
  | 'apartment'
  | 'building'
  | 'surroundings'
  | 'common-areas'
  | 'other';

type TicketBase = {
  id: string;
  ticketNumber: number;
  title: string;
  description: string;
  societyId: string;
  status: TicketStatus;
  unreadMessages: number;
  totalImages?: number;
  totalDocuments?: number;
  variant: TicketVariant;
  space?: TicketReportSpace;
  createdAt: string;
  updatedAt?: string;
};

export type ITicket = TicketBase & {
  author: 'me' | 'society';
  lastMessage?: {
    updatedAt: string;
    createdAt: string;
    message: string;
    mediaIds: string[];
    type: 'me' | 'society';
    documentIds: string[];
  };
};

export type ITicketBoard = TicketBase & {
  authorId: string;
  lastMessage?: {
    authorId: string;
    updatedAt: string;
    createdAt: string;
    message: string;
    mediaIds: string[];
    documentIds: string[];
  };
  customer?: {
    id: string;
    name: string;
    surname: string;
    avatarUrl?: string;
  };
  assignedUser?: {
    id: string;
    name: string;
    surname: string;
    avatarUrl?: string;
  };
};

type MessageBase = {
  id: string;
  ticketId: string;
  message?: string;
  documents?: IDocumentModel[];
  media?: IMediaModel[];
  createdAt: string;
  updatedAt?: string;
};

export type ITicketMessage = MessageBase & {
  author: {
    type: 'me' | 'society';
  };
};
export type ITicketMessageBoard = MessageBase & {
  author: {
    id: string;
    name: string;
    surname: string;
    avatarUrl?: string;
  };
};
